import * as React from "react";
import { connect } from "react-redux";
import { DispatchFunc } from "../../../../../store/ActionTypes";
import { FreeBookingItem } from "../../../../../store/ManualBooking/Types";
import { ManualBookingTypeDisplay } from "../../../../../store/ManualBooking/Displays";
import { getManualBookingTypeColor } from "../../../../utils/FormatHelpers";
import { FillUp } from "@vwpfs/mary-air-lib/components/air/04-helpers/FillUp";
import { Currency } from "@vwpfs/mary-air-lib/components/air/05-atoms/CurrencyDisplay";
import { RowData, Table, TableData } from "@vwpfs/mary-air-lib/components/air/06-molecules/Table";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { Navbar } from "@vwpfs/mary-air-lib/components/air/07-organisms";
import { NavbarStack,
    NavbarStackContent, NavbarStackRight } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Stack";
import { NavbarTitle } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Title";
import { NavbarIcon } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Icon";
import { ThemeBreakpoints, ThemePalette, ThemeShadowSizes } from "@vwpfs/mary-air-lib/theme/_Types";
import { isNegative } from "@vwpfs/mary-air-lib/utils/FormatHelpers";
import { modalClose } from "../../../../../utils/redux/ActionTypes";
import { FlexColumn } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Column";
import { FlexRow } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Row";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { Badge } from "@vwpfs/mary-air-lib/components/air/05-atoms/Badge";

/**
 *
 */
interface OwnProps {
    modalID: string;
    id: string;
    items: FreeBookingItem[];
}

/**
 *
 */
interface DispatchProps {
    closeModal: (id: string) => void;
}

/**
 *
 */
type Props = OwnProps & DispatchProps;

/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    closeModal: (id: string) => {
        dispatch(modalClose(id));
    },
});

/**
 *
 */
export class DetailModalComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
        this.state = {};
        this.getProcessedRows = this.getProcessedRows.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.resultsData = this.resultsData.bind(this);
    }

    public render() {
        return (
            <FlexColumn>
                <FlexRow isFixed>
                    <Navbar
                        theme={{
                            palette: ThemePalette.BRAND_ACCENT,
                        }}
                    >
                        <NavbarStack>
                            <NavbarStackContent>
                                <NavbarTitle>
                                    Free booking summary
                                </NavbarTitle>
                            </NavbarStackContent>
                            <NavbarStackRight>
                                <NavbarIcon>
                                    <Button
                                        icon={IconNames.TIMES}
                                        link={{ onClick: this.closeModal() }}
                                    />
                                </NavbarIcon>
                            </NavbarStackRight>
                        </NavbarStack>
                    </Navbar>
                </FlexRow>
                <FlexRow
                    theme={{
                        palette: ThemePalette.CONTRAST_PRIMARY,
                    }}
                >
                    <FlexColumn
                        style={{
                            maxHeight: "calc(98vh - 120px)",
                        }}
                    >
                        <FlexRow isScrollable >
                            <div style={{ width: "100%" }}>
                                <FillUp>
                                    <Table
                                        hasActions
                                        data={{
                                            columns: this.resultsData().columns,
                                            rows: this.resultsData().rows,
                                            sort: this.resultsData().sort,
                                        }}
                                    />
                                </FillUp>
                            </div>
                        </FlexRow>
                    </FlexColumn>
                </FlexRow>
                <FlexRow isFixed>
                    <FlexColumn
                        theme={{
                            palette: ThemePalette.CONTRAST_PRIMARY,
                        }}
                    >
                        <Container
                            theme={{
                                padding: { "": { y: 3 } },
                            }}
                        >
                            <ButtonsWrapper
                                defaultOrientation={Orientation.HORIZONTAL}
                                orientations={{
                                    [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                                    [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                                }}
                                alignment={Alignment.RIGHT}
                            >
                                <Button
                                    theme={{ palette: ThemePalette.BRAND_ACCENT }}
                                    link={{ onClick: this.closeModal() }}
                                >
                                    Close
                                </Button>
                            </ButtonsWrapper>
                        </Container>
                    </FlexColumn>
                </FlexRow>
            </FlexColumn >
        );
    }

    /**
     *
     */
    private getProcessedRows(): RowData[] {
        return this.props.items.map((row, _index) => ({
            id: row.id,
            data: [
                row.objectType ?
                    (
                        <Badge
                            theme={{
                                palette: getManualBookingTypeColor(row.objectType),
                                shadow: ThemeShadowSizes.TINY,
                            }}
                        >
                            {ManualBookingTypeDisplay[row.objectType]}
                        </Badge>
                    )
                    : "",
                row.description ?? "",
                !isNegative(row.amount) ?
                    (
                        <h6>
                            <Currency value={row.amount} />
                        </h6>
                    ) : "",
                isNegative(row.amount) ?
                    (
                        <h6>
                            <Currency value={- row.amount} />
                        </h6>
                    ) : "",
            ],
        }));
    }

    private closeModal() {
        return () => this.props.closeModal(this.props.modalID);
    }

    /**
     *
     */
    private resultsData(): TableData {
        return {
            sort: undefined,
            columns: [
                {
                    label: "Type",
                },
                {
                    label: "Number / Code",
                },
                {
                    label: "Debit balance",
                },
                {
                    label: "Credit balance",
                },
            ],
            rows: this.getProcessedRows(),
        };
    }
}

/**
 *
 */
export const DetailModal = connect(
    undefined,
    mapDispatchToProps,
)(DetailModalComp);
